import { Airports } from "@constants/airports";
import { httpWeatherService } from "@services/HttpService";
import { XMLParser } from "fast-xml-parser";
const iataToAerodromeForecastMap = {
    OSL: "aw_engm",
    BGO: "aw_enbr",
    SVG: "aw_enzv",
};
const iataToLocationIdMap = {
    OSL: "0503",
    BGO: "0612",
    TRD: "0504",
    SVG: "0611",
};
export const getAviationForecast = async (iata) => {
    var _a, _b, _c, _d;
    const forecast = iataToAerodromeForecastMap[iata.toUpperCase()];
    if (!forecast)
        return null;
    const response = await httpWeatherService.get(`/aviationforecast/1.6/?forecast=${forecast}`);
    const parser = new XMLParser({ ignoreAttributes: false, attributeNamePrefix: "" });
    const jsonObj = parser.parse(response.data);
    const times = Array.isArray((_a = jsonObj.weather) === null || _a === void 0 ? void 0 : _a.time)
        ? jsonObj.weather.time
        : [(_b = jsonObj.weather) === null || _b === void 0 ? void 0 : _b.time].filter(Boolean);
    const now = new Date();
    const nilValues = new Set(["- NIL", "-", "NIL"]);
    for (const time of times) {
        if (!(time === null || time === void 0 ? void 0 : time.vfrom) || !(time === null || time === void 0 ? void 0 : time.vto))
            continue;
        const to = new Date(time.vto);
        // Skip past forecasts
        if (to <= now)
            continue;
        const parameters = [];
        const forecasttypes = Array.isArray(time.forecasttype)
            ? time.forecasttype
            : [time.forecasttype];
        for (const ft of forecasttypes) {
            const location = ft === null || ft === void 0 ? void 0 : ft.location;
            if (!(location === null || location === void 0 ? void 0 : location.parameter))
                continue;
            for (const param of location.parameter) {
                if ((param === null || param === void 0 ? void 0 : param.name) == 'rmk')
                    continue; // Skip remarks
                const value = (_c = param.in) === null || _c === void 0 ? void 0 : _c.trim();
                const text = (_d = param.text) === null || _d === void 0 ? void 0 : _d.replace(/^\d+\.\s*/, "").replace(/:$/, "").trim();
                if (value && !nilValues.has(value) && text) {
                    parameters.push({ text, in: value });
                }
            }
        }
        if (parameters.length > 0) {
            return {
                from: time.vfrom,
                to: time.vto,
                parameters,
            };
        }
    }
    return null;
};
export const getWeatherData = async (iata) => {
    var _a;
    const coordinates = (_a = Airports.find((airport) => airport.iata.toUpperCase() === iata.toUpperCase())) === null || _a === void 0 ? void 0 : _a.coordinates;
    if (!coordinates) {
        console.error("Could not find coordinates for airport with iata: ", iata);
        return {};
    }
    const response = await httpWeatherService.get("/locationforecast/2.0/complete", {
        //OSL coordinates
        params: coordinates,
    });
    return response.data;
};
export const getTextForecast = async (iata) => {
    var _a, _b, _c, _d;
    const locationId = iataToLocationIdMap[iata];
    const response = await httpWeatherService.get("/textforecast/2.0/landoverview");
    const parser = new XMLParser({
        ignoreAttributes: false, // Ensure attributes are not ignored
        attributeNamePrefix: "", // Remove prefix from attribute names
    });
    const jsonObj = parser.parse(response.data);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const areaForecast = (_d = (_c = (_b = (_a = jsonObj === null || jsonObj === void 0 ? void 0 : jsonObj.textforecast) === null || _a === void 0 ? void 0 : _a.time[0]) === null || _b === void 0 ? void 0 : _b.forecasttype) === null || _c === void 0 ? void 0 : _c.location) === null || _d === void 0 ? void 0 : _d.find((x) => x.id.includes(locationId));
    return {
        text: areaForecast ? areaForecast["#text"] : "No forecast available",
    };
};
